import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-square-icon-button',
  templateUrl: './square-icon-button.component.html',
  styleUrls: ['./square-icon-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatButtonModule],
})

export class SquareIconButtonComponent {
    readonly iconPath = input<string>('');
    readonly label = input<string>('Button');
    readonly value = input<string>('');
    readonly selectedValue = input<string>('');

    readonly buttonClick = output<string>();
    
    get isActive(): boolean {
        return this.selectedValue() === this.value();
    }

    handleClick() {
        this.buttonClick.emit(this.value());
    }
}
